import dayjs from 'dayjs'
import numbro from 'numbro'

export default {
  methods: {
    // Gestionarea schimbărilor de date pentru perioada principală
    handlePeriodDateChange(newVal) {
      this.period.start_date = this.formatDateToISO(newVal.start_date)
      this.period.end_date = this.formatDateToISO(newVal.end_date)
      this.getDataForChart()
    },

    // Gestionarea schimbărilor de date pentru comparație
    handleCompareDateChange(newVal) {
      this.getDataForChart(newVal)
    },

    // Formatare date în format ISO
    formatDateToISO(date) {
      return new Date(date).toISOString().replace('.000Z', '.000000Z')
    },

    // Calculul valorilor totale pentru metrici
    calcValues(data) {
      const metrics = {
        clicks: 0,
        impressions: 0,
      }

      const totalizator = {}

      // Calculăm totalurile pentru fiecare metrică
      Object.entries(data).forEach(([key, values]) => {
        const value = values.reduce((sum, val) => sum + val, 0)
        metrics[key] = value

        totalizator[key] = {
          numbro: numbro(value).format({ average: true }),
          value,
        }
      })

      // Calculăm CTR
      const ctr = metrics.clicks / metrics.impressions
      totalizator.ctr = {
        numbro: numbro(ctr).format({ output: 'percent', mantissa: 2 }),
        value: ctr,
      }

      return totalizator
    },

    // Extragerea datelor pentru grafice
    extractDataset(array) {
      const tempData = this.aggregateDataByDate(array)
      const dataSet = this.transformToDataSet(tempData)

      return {
        dataSet,
        total: this.calcValues(dataSet),
      }
    },

    // Agregarea datelor pe date
    aggregateDataByDate(array) {
      const tempData = {}

      array.forEach((item) => {
        Object.entries(item).forEach(([key, values]) => {
          if (!Array.isArray(values)) return

          if (!tempData[key]) {
            tempData[key] = {}
          }

          values.forEach((entry) => {
            if (entry?.value !== undefined && entry?.date) {
              tempData[key][entry.date] = (tempData[key][entry.date] || 0) + entry.value
            }
          })
        })
      })

      return tempData
    },

    // Transformarea datelor agregate în format pentru grafice
    transformToDataSet(tempData) {
      const dataSet = {}
      Object.entries(tempData).forEach(([key, values]) => {
        dataSet[key] = Object.values(values)
      })
      return dataSet
    },

    // Extragerea datelor unice pentru axe
    extrageDateUnice(array) {
      const dataUnice = {}

      Object.entries(array[0] || {}).forEach(([key, values]) => {
        if (!Array.isArray(values)) return

        const dateSet = new Set()
        array.forEach((item) => {
          item[key]?.forEach((entry) => {
            if (entry?.date) {
              dateSet.add(dayjs(entry.date).format('D MMM'))
            }
          })
        })

        dataUnice[key] = Array.from(dateSet)
      })

      return dataUnice
    },

    // Alinierea datelor pentru comparație
    alignFullComparisonData(mainX, compareData) {
      const compareX = compareData?.xaxis?.impressions

      if (!Array.isArray(compareX) || compareX.length === 0) {
        return this.createEmptyComparisonData(mainX, compareData)
      }

      return this.alignComparisonData(mainX, compareX, compareData)
    },

    // Crearea datelor goale pentru comparație
    createEmptyComparisonData(mainX, compareData) {
      const emptyDataSet = {}
      const totalLength = mainX.length

      Object.keys(compareData.set.dataSet).forEach((key) => {
        emptyDataSet[key] = Array(totalLength).fill(null)
      })

      return {
        ...compareData,
        set: {
          ...compareData.set,
          dataSet: emptyDataSet,
        },
        xaxis: this.createXAxisData(mainX),
      }
    },

    // Alinierea datelor de comparație
    alignComparisonData(mainX, compareX, compareData) {
      const offset = Math.max(
        0,
        mainX.findIndex((date) => date === compareX[0])
      )
      const totalLength = mainX.length

      const newDataSet = {}
      Object.entries(compareData.set.dataSet).forEach(([key, original]) => {
        if (!Array.isArray(original)) return

        let padded = Array(offset).fill(null).concat(original)
        if (padded.length > totalLength) padded = padded.slice(0, totalLength)
        while (padded.length < totalLength) padded.push(null)

        newDataSet[key] = padded
      })

      return {
        ...compareData,
        set: {
          ...compareData.set,
          dataSet: newDataSet,
        },
        xaxis: this.createXAxisData(mainX),
      }
    },

    // Crearea datelor pentru axe
    createXAxisData(mainX) {
      return {
        impressions: mainX,
        clicks: mainX,
        ctr: mainX,
        unique_reach: mainX,
      }
    },
  },
}
